export const NOTIFICATIONS_TYPES = {
  ERROR: 'error',
  ALERT: 'alert',
  INFO: 'info',
  SUCCESS: 'success',
};
